/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_To_LabelInputs */



/**
* | output |
* | --- |
* | "To member" |
*
* @param {Promo_Movement_To_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_to_label = /** @type {((inputs?: Promo_Movement_To_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_To_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vers le membre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Al miembro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Para o membro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Al membro")
	return /** @type {LocalizedString} */ ("To member")
});